import React from "react";
import TextBox from "components/TextBox/TextBox";
import { PageBuilderTextBoxFragment } from "types/graphql-types";
import { graphql } from "gatsby";
import PageBuilderSectionTitle from "./PageBuilderSectionTitle";

export type PageBuilderTextBoxProps = PageBuilderTextBoxFragment;

const PageBuilderTextBox: React.FC<PageBuilderTextBoxProps> = ({
  heading,
  content,
  boxed
}) => (
  <React.Fragment>
    {heading && <PageBuilderSectionTitle {...heading} />}
    <TextBox fontSize="medium" boxed={boxed} content={content?.localized} />
  </React.Fragment>
);

export default PageBuilderTextBox;

export const fragments = graphql`
  fragment PageBuilderTextBox on SanityTextBox {
    _key
    heading {
      ...SectionTitle
      ...SectionTitleCTAs
    }
    content {
      localized
    }
    boxed
  }
`;
